/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  LogProbToken,
  LogProbToken$inboundSchema,
  LogProbToken$Outbound,
  LogProbToken$outboundSchema,
} from "./logprobtoken.js";

export type ResponseOutputTextDoneEvent = {
  type: "response.output_text.done";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  contentIndex: number;
  text: string;
  logprobs?: Array<LogProbToken> | undefined;
};

/** @internal */
export const ResponseOutputTextDoneEvent$inboundSchema: z.ZodType<
  ResponseOutputTextDoneEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.output_text.done"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  content_index: z.number().int(),
  text: z.string(),
  logprobs: z.array(LogProbToken$inboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
    "content_index": "contentIndex",
  });
});
/** @internal */
export type ResponseOutputTextDoneEvent$Outbound = {
  type: "response.output_text.done";
  sequence_number: number;
  item_id: string;
  output_index: number;
  content_index: number;
  text: string;
  logprobs?: Array<LogProbToken$Outbound> | undefined;
};

/** @internal */
export const ResponseOutputTextDoneEvent$outboundSchema: z.ZodType<
  ResponseOutputTextDoneEvent$Outbound,
  z.ZodTypeDef,
  ResponseOutputTextDoneEvent
> = z.object({
  type: z.literal("response.output_text.done"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
  contentIndex: z.number().int(),
  text: z.string(),
  logprobs: z.array(LogProbToken$outboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
    contentIndex: "content_index",
  });
});

export function responseOutputTextDoneEventToJSON(
  responseOutputTextDoneEvent: ResponseOutputTextDoneEvent,
): string {
  return JSON.stringify(
    ResponseOutputTextDoneEvent$outboundSchema.parse(
      responseOutputTextDoneEvent,
    ),
  );
}
export function responseOutputTextDoneEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseOutputTextDoneEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseOutputTextDoneEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseOutputTextDoneEvent' from JSON`,
  );
}
